/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateNotificationDto,
  CreateSettlementDto,
  OffboardingControllerListV1200,
  OffboardingControllerListV1Params,
  OffboardingDetailDto,
  RecordTerminationDto,
  RemoveResponseDto,
  StartOffboardingDto,
  UpdateNotificationDto,
  UpdateRetentionDto,
  UpdateSettlementDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getOffboardingControllerListV1Url = (params?: OffboardingControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/offboardings?${stringifiedParams}` : `/v1/offboardings`
}

/**
 * @summary Offboardings, with their completion
 */
export const offboardingControllerListV1 = async (params?: OffboardingControllerListV1Params, options?: RequestInit): Promise<OffboardingControllerListV1200> => {

  return apiRequest<OffboardingControllerListV1200>(getOffboardingControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOffboardingControllerListV1QueryKey = (params?: OffboardingControllerListV1Params,) => {
    return [
    `/v1/offboardings`, ...(params ? [params] : [])
    ] as const;
    }


export const getOffboardingControllerListV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerListV1>>, TError = unknown>(params?: OffboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerListV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerListV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerListV1>>> = ({ signal }) => offboardingControllerListV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerListV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerListV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerListV1>>>
export type OffboardingControllerListV1QueryError = unknown


export function useOffboardingControllerListV1<TData = Awaited<ReturnType<typeof offboardingControllerListV1>>, TError = unknown>(
 params: undefined |  OffboardingControllerListV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerListV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerListV1<TData = Awaited<ReturnType<typeof offboardingControllerListV1>>, TError = unknown>(
 params?: OffboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerListV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerListV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerListV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerListV1<TData = Awaited<ReturnType<typeof offboardingControllerListV1>>, TError = unknown>(
 params?: OffboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Offboardings, with their completion
 */

export function useOffboardingControllerListV1<TData = Awaited<ReturnType<typeof offboardingControllerListV1>>, TError = unknown>(
 params?: OffboardingControllerListV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerListV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerListV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerStartV1Url = () => {




  return `/v1/offboardings`
}

/**
 * Creates the offboarding, its four steps, the default regulatory filings and the retention schedule in one transaction. Returns 409 if the player already has an offboarding in progress.
 * @summary Begin offboarding a player
 */
export const offboardingControllerStartV1 = async (startOffboardingDto: StartOffboardingDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerStartV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startOffboardingDto)
  }
);}





export const getOffboardingControllerStartV1QueryKey = (startOffboardingDto?: StartOffboardingDto,) => {
    return [
    'POST', `/v1/offboardings`, startOffboardingDto
    ] as const;
    }


export const getOffboardingControllerStartV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError = void>(startOffboardingDto: StartOffboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerStartV1QueryKey(startOffboardingDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerStartV1>>> = ({ signal }) => offboardingControllerStartV1(startOffboardingDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerStartV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerStartV1>>>
export type OffboardingControllerStartV1QueryError = void


export function useOffboardingControllerStartV1<TData = Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError = void>(
 startOffboardingDto: StartOffboardingDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerStartV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerStartV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerStartV1<TData = Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError = void>(
 startOffboardingDto: StartOffboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerStartV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerStartV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerStartV1<TData = Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError = void>(
 startOffboardingDto: StartOffboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Begin offboarding a player
 */

export function useOffboardingControllerStartV1<TData = Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError = void>(
 startOffboardingDto: StartOffboardingDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerStartV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerStartV1QueryOptions(startOffboardingDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerFindOneV1Url = (id: string,) => {




  return `/v1/offboardings/${id}`
}

/**
 * @summary The whole offboarding screen in one response
 */
export const offboardingControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOffboardingControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/offboardings/${id}`
    ] as const;
    }


export const getOffboardingControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>> = ({ signal }) => offboardingControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>>
export type OffboardingControllerFindOneV1QueryError = unknown


export function useOffboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The whole offboarding screen in one response
 */

export function useOffboardingControllerFindOneV1<TData = Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerCancelV1Url = (id: string,) => {




  return `/v1/offboardings/${id}`
}

/**
 * Deletes the checklist and its records. A COMPLETED offboarding cannot be cancelled — it is the record that a representation ended, and removing it would erase history rather than correct a mistake.
 * @summary Cancel an offboarding started in error
 */
export const offboardingControllerCancelV1 = async (id: string, options?: RequestInit): Promise<RemoveResponseDto> => {

  return apiRequest<RemoveResponseDto>(getOffboardingControllerCancelV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOffboardingControllerCancelV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/offboardings/${id}`
    ] as const;
    }


export const getOffboardingControllerCancelV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerCancelV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerCancelV1>>> = ({ signal }) => offboardingControllerCancelV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerCancelV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerCancelV1>>>
export type OffboardingControllerCancelV1QueryError = void


export function useOffboardingControllerCancelV1<TData = Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerCancelV1<TData = Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerCancelV1<TData = Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cancel an offboarding started in error
 */

export function useOffboardingControllerCancelV1<TData = Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerCancelV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerCompleteV1Url = (id: string,) => {




  return `/v1/offboardings/${id}/complete`
}

/**
 * The terminal action. Requires every step done, and sets the player to `unrepresented`. Unlike onboarding, this is explicit rather than a consequence of the last task — it is a decision someone signs their name to, and the audit entry names them.
 * @summary End the representation
 */
export const offboardingControllerCompleteV1 = async (id: string, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerCompleteV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOffboardingControllerCompleteV1QueryKey = (id: string,) => {
    return [
    'POST', `/v1/offboardings/${id}/complete`
    ] as const;
    }


export const getOffboardingControllerCompleteV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerCompleteV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>> = ({ signal }) => offboardingControllerCompleteV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerCompleteV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>>
export type OffboardingControllerCompleteV1QueryError = void


export function useOffboardingControllerCompleteV1<TData = Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerCompleteV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerCompleteV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerCompleteV1<TData = Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerCompleteV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerCompleteV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerCompleteV1<TData = Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary End the representation
 */

export function useOffboardingControllerCompleteV1<TData = Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerCompleteV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerCompleteV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerRecordTerminationV1Url = (id: string,) => {




  return `/v1/offboardings/${id}/termination`
}

/**
 * @summary Record the contract termination
 */
export const offboardingControllerRecordTerminationV1 = async (id: string,
    recordTerminationDto: RecordTerminationDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerRecordTerminationV1Url(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordTerminationDto)
  }
);}





export const getOffboardingControllerRecordTerminationV1QueryKey = (id: string,
    recordTerminationDto?: RecordTerminationDto,) => {
    return [
    'PUT', `/v1/offboardings/${id}/termination`, recordTerminationDto
    ] as const;
    }


export const getOffboardingControllerRecordTerminationV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError = unknown>(id: string,
    recordTerminationDto: RecordTerminationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerRecordTerminationV1QueryKey(id,recordTerminationDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>> = ({ signal }) => offboardingControllerRecordTerminationV1(id,recordTerminationDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerRecordTerminationV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>>
export type OffboardingControllerRecordTerminationV1QueryError = unknown


export function useOffboardingControllerRecordTerminationV1<TData = Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError = unknown>(
 id: string,
    recordTerminationDto: RecordTerminationDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerRecordTerminationV1<TData = Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError = unknown>(
 id: string,
    recordTerminationDto: RecordTerminationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerRecordTerminationV1<TData = Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError = unknown>(
 id: string,
    recordTerminationDto: RecordTerminationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Record the contract termination
 */

export function useOffboardingControllerRecordTerminationV1<TData = Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError = unknown>(
 id: string,
    recordTerminationDto: RecordTerminationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRecordTerminationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerRecordTerminationV1QueryOptions(id,recordTerminationDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerAddSettlementV1Url = (id: string,) => {




  return `/v1/offboardings/${id}/settlements`
}

/**
 * @summary Add a reconciliation line
 */
export const offboardingControllerAddSettlementV1 = async (id: string,
    createSettlementDto: CreateSettlementDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerAddSettlementV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSettlementDto)
  }
);}





export const getOffboardingControllerAddSettlementV1QueryKey = (id: string,
    createSettlementDto?: CreateSettlementDto,) => {
    return [
    'POST', `/v1/offboardings/${id}/settlements`, createSettlementDto
    ] as const;
    }


export const getOffboardingControllerAddSettlementV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError = unknown>(id: string,
    createSettlementDto: CreateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerAddSettlementV1QueryKey(id,createSettlementDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>> = ({ signal }) => offboardingControllerAddSettlementV1(id,createSettlementDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerAddSettlementV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>>
export type OffboardingControllerAddSettlementV1QueryError = unknown


export function useOffboardingControllerAddSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError = unknown>(
 id: string,
    createSettlementDto: CreateSettlementDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerAddSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError = unknown>(
 id: string,
    createSettlementDto: CreateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerAddSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError = unknown>(
 id: string,
    createSettlementDto: CreateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a reconciliation line
 */

export function useOffboardingControllerAddSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError = unknown>(
 id: string,
    createSettlementDto: CreateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddSettlementV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerAddSettlementV1QueryOptions(id,createSettlementDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerUpdateSettlementV1Url = (id: string,
    settlementId: string,) => {




  return `/v1/offboardings/${id}/settlements/${settlementId}`
}

/**
 * @summary Amend a reconciliation line
 */
export const offboardingControllerUpdateSettlementV1 = async (id: string,
    settlementId: string,
    updateSettlementDto: UpdateSettlementDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerUpdateSettlementV1Url(id,settlementId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSettlementDto)
  }
);}





export const getOffboardingControllerUpdateSettlementV1QueryKey = (id: string,
    settlementId: string,
    updateSettlementDto?: UpdateSettlementDto,) => {
    return [
    'PATCH', `/v1/offboardings/${id}/settlements/${settlementId}`, updateSettlementDto
    ] as const;
    }


export const getOffboardingControllerUpdateSettlementV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError = unknown>(id: string,
    settlementId: string,
    updateSettlementDto: UpdateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerUpdateSettlementV1QueryKey(id,settlementId,updateSettlementDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>> = ({ signal }) => offboardingControllerUpdateSettlementV1(id,settlementId,updateSettlementDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && settlementId !== null && settlementId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerUpdateSettlementV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>>
export type OffboardingControllerUpdateSettlementV1QueryError = unknown


export function useOffboardingControllerUpdateSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string,
    updateSettlementDto: UpdateSettlementDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerUpdateSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string,
    updateSettlementDto: UpdateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerUpdateSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string,
    updateSettlementDto: UpdateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Amend a reconciliation line
 */

export function useOffboardingControllerUpdateSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string,
    updateSettlementDto: UpdateSettlementDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateSettlementV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerUpdateSettlementV1QueryOptions(id,settlementId,updateSettlementDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerRemoveSettlementV1Url = (id: string,
    settlementId: string,) => {




  return `/v1/offboardings/${id}/settlements/${settlementId}`
}

/**
 * @summary Remove a reconciliation line
 */
export const offboardingControllerRemoveSettlementV1 = async (id: string,
    settlementId: string, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerRemoveSettlementV1Url(id,settlementId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOffboardingControllerRemoveSettlementV1QueryKey = (id: string,
    settlementId: string,) => {
    return [
    'DELETE', `/v1/offboardings/${id}/settlements/${settlementId}`
    ] as const;
    }


export const getOffboardingControllerRemoveSettlementV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError = unknown>(id: string,
    settlementId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerRemoveSettlementV1QueryKey(id,settlementId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>> = ({ signal }) => offboardingControllerRemoveSettlementV1(id,settlementId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && settlementId !== null && settlementId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerRemoveSettlementV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>>
export type OffboardingControllerRemoveSettlementV1QueryError = unknown


export function useOffboardingControllerRemoveSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerRemoveSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerRemoveSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a reconciliation line
 */

export function useOffboardingControllerRemoveSettlementV1<TData = Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError = unknown>(
 id: string,
    settlementId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerRemoveSettlementV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerRemoveSettlementV1QueryOptions(id,settlementId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerAddNotificationV1Url = (id: string,) => {




  return `/v1/offboardings/${id}/notifications`
}

/**
 * @summary Add a regulatory filing to the workflow
 */
export const offboardingControllerAddNotificationV1 = async (id: string,
    createNotificationDto: CreateNotificationDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerAddNotificationV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createNotificationDto)
  }
);}





export const getOffboardingControllerAddNotificationV1QueryKey = (id: string,
    createNotificationDto?: CreateNotificationDto,) => {
    return [
    'POST', `/v1/offboardings/${id}/notifications`, createNotificationDto
    ] as const;
    }


export const getOffboardingControllerAddNotificationV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError = unknown>(id: string,
    createNotificationDto: CreateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerAddNotificationV1QueryKey(id,createNotificationDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>> = ({ signal }) => offboardingControllerAddNotificationV1(id,createNotificationDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerAddNotificationV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>>
export type OffboardingControllerAddNotificationV1QueryError = unknown


export function useOffboardingControllerAddNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError = unknown>(
 id: string,
    createNotificationDto: CreateNotificationDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerAddNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError = unknown>(
 id: string,
    createNotificationDto: CreateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerAddNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError = unknown>(
 id: string,
    createNotificationDto: CreateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a regulatory filing to the workflow
 */

export function useOffboardingControllerAddNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError = unknown>(
 id: string,
    createNotificationDto: CreateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerAddNotificationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerAddNotificationV1QueryOptions(id,createNotificationDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerUpdateNotificationV1Url = (id: string,
    notificationId: string,) => {




  return `/v1/offboardings/${id}/notifications/${notificationId}`
}

/**
 * Records that a filing was made. Nothing is transmitted to FIFA or any association — see OFFBOARDING.md and docs/PRODUCTION.md.
 * @summary Record the outcome of a filing
 */
export const offboardingControllerUpdateNotificationV1 = async (id: string,
    notificationId: string,
    updateNotificationDto: UpdateNotificationDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerUpdateNotificationV1Url(id,notificationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateNotificationDto)
  }
);}





export const getOffboardingControllerUpdateNotificationV1QueryKey = (id: string,
    notificationId: string,
    updateNotificationDto?: UpdateNotificationDto,) => {
    return [
    'PATCH', `/v1/offboardings/${id}/notifications/${notificationId}`, updateNotificationDto
    ] as const;
    }


export const getOffboardingControllerUpdateNotificationV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError = unknown>(id: string,
    notificationId: string,
    updateNotificationDto: UpdateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerUpdateNotificationV1QueryKey(id,notificationId,updateNotificationDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>> = ({ signal }) => offboardingControllerUpdateNotificationV1(id,notificationId,updateNotificationDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && notificationId !== null && notificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerUpdateNotificationV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>>
export type OffboardingControllerUpdateNotificationV1QueryError = unknown


export function useOffboardingControllerUpdateNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError = unknown>(
 id: string,
    notificationId: string,
    updateNotificationDto: UpdateNotificationDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerUpdateNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError = unknown>(
 id: string,
    notificationId: string,
    updateNotificationDto: UpdateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerUpdateNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError = unknown>(
 id: string,
    notificationId: string,
    updateNotificationDto: UpdateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Record the outcome of a filing
 */

export function useOffboardingControllerUpdateNotificationV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError = unknown>(
 id: string,
    notificationId: string,
    updateNotificationDto: UpdateNotificationDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateNotificationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerUpdateNotificationV1QueryOptions(id,notificationId,updateNotificationDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerSubmitPendingV1Url = (id: string,) => {




  return `/v1/offboardings/${id}/notifications/submit-pending`
}

/**
 * @summary Mark every pending filing as submitted
 */
export const offboardingControllerSubmitPendingV1 = async (id: string, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerSubmitPendingV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOffboardingControllerSubmitPendingV1QueryKey = (id: string,) => {
    return [
    'POST', `/v1/offboardings/${id}/notifications/submit-pending`
    ] as const;
    }


export const getOffboardingControllerSubmitPendingV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerSubmitPendingV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>> = ({ signal }) => offboardingControllerSubmitPendingV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerSubmitPendingV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>>
export type OffboardingControllerSubmitPendingV1QueryError = unknown


export function useOffboardingControllerSubmitPendingV1<TData = Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerSubmitPendingV1<TData = Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerSubmitPendingV1<TData = Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mark every pending filing as submitted
 */

export function useOffboardingControllerSubmitPendingV1<TData = Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerSubmitPendingV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerSubmitPendingV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerUpdateRetentionV1Url = (id: string,
    retentionId: string,) => {




  return `/v1/offboardings/${id}/retentions/${retentionId}`
}

/**
 * Takes effect at archiving. An already-archived category keeps the purge date it was given, because a retention schedule that moves is not a schedule.
 * @summary Change how long a data category is kept
 */
export const offboardingControllerUpdateRetentionV1 = async (id: string,
    retentionId: string,
    updateRetentionDto: UpdateRetentionDto, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerUpdateRetentionV1Url(id,retentionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateRetentionDto)
  }
);}





export const getOffboardingControllerUpdateRetentionV1QueryKey = (id: string,
    retentionId: string,
    updateRetentionDto?: UpdateRetentionDto,) => {
    return [
    'PATCH', `/v1/offboardings/${id}/retentions/${retentionId}`, updateRetentionDto
    ] as const;
    }


export const getOffboardingControllerUpdateRetentionV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError = unknown>(id: string,
    retentionId: string,
    updateRetentionDto: UpdateRetentionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerUpdateRetentionV1QueryKey(id,retentionId,updateRetentionDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>> = ({ signal }) => offboardingControllerUpdateRetentionV1(id,retentionId,updateRetentionDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && retentionId !== null && retentionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerUpdateRetentionV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>>
export type OffboardingControllerUpdateRetentionV1QueryError = unknown


export function useOffboardingControllerUpdateRetentionV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError = unknown>(
 id: string,
    retentionId: string,
    updateRetentionDto: UpdateRetentionDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerUpdateRetentionV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError = unknown>(
 id: string,
    retentionId: string,
    updateRetentionDto: UpdateRetentionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerUpdateRetentionV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError = unknown>(
 id: string,
    retentionId: string,
    updateRetentionDto: UpdateRetentionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Change how long a data category is kept
 */

export function useOffboardingControllerUpdateRetentionV1<TData = Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError = unknown>(
 id: string,
    retentionId: string,
    updateRetentionDto: UpdateRetentionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerUpdateRetentionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerUpdateRetentionV1QueryOptions(id,retentionId,updateRetentionDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerArchiveV1Url = (id: string,
    retentionId: string,) => {




  return `/v1/offboardings/${id}/retentions/${retentionId}/archive`
}

/**
 * Records the intent and the schedule. NO DATA IS MOVED OR DELETED — there is no purge job yet. See docs/PRODUCTION.md.
 * @summary Archive one data category and fix its purge date
 */
export const offboardingControllerArchiveV1 = async (id: string,
    retentionId: string, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerArchiveV1Url(id,retentionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOffboardingControllerArchiveV1QueryKey = (id: string,
    retentionId: string,) => {
    return [
    'POST', `/v1/offboardings/${id}/retentions/${retentionId}/archive`
    ] as const;
    }


export const getOffboardingControllerArchiveV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError = unknown>(id: string,
    retentionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerArchiveV1QueryKey(id,retentionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>> = ({ signal }) => offboardingControllerArchiveV1(id,retentionId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && retentionId !== null && retentionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerArchiveV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>>
export type OffboardingControllerArchiveV1QueryError = unknown


export function useOffboardingControllerArchiveV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError = unknown>(
 id: string,
    retentionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerArchiveV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerArchiveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerArchiveV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError = unknown>(
 id: string,
    retentionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerArchiveV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerArchiveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerArchiveV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError = unknown>(
 id: string,
    retentionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Archive one data category and fix its purge date
 */

export function useOffboardingControllerArchiveV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError = unknown>(
 id: string,
    retentionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerArchiveV1QueryOptions(id,retentionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOffboardingControllerArchiveAllV1Url = (id: string,) => {




  return `/v1/offboardings/${id}/retentions/archive-all`
}

/**
 * @summary Archive every category not already archived
 */
export const offboardingControllerArchiveAllV1 = async (id: string, options?: RequestInit): Promise<OffboardingDetailDto> => {

  return apiRequest<OffboardingDetailDto>(getOffboardingControllerArchiveAllV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOffboardingControllerArchiveAllV1QueryKey = (id: string,) => {
    return [
    'POST', `/v1/offboardings/${id}/retentions/archive-all`
    ] as const;
    }


export const getOffboardingControllerArchiveAllV1QueryOptions = <TData = Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffboardingControllerArchiveAllV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>> = ({ signal }) => offboardingControllerArchiveAllV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffboardingControllerArchiveAllV1QueryResult = NonNullable<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>>
export type OffboardingControllerArchiveAllV1QueryError = unknown


export function useOffboardingControllerArchiveAllV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerArchiveAllV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>,
          TError,
          Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffboardingControllerArchiveAllV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Archive every category not already archived
 */

export function useOffboardingControllerArchiveAllV1<TData = Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offboardingControllerArchiveAllV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffboardingControllerArchiveAllV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






